import { connect } from 'react-redux';
import _ from 'lodash';

import {
  getDashboardEventFilter,
  getDashboardEventName,
  getDashboardEventOthersFilter,
  getDashboardEvents,
  getFieldPathKeys,
  getFieldPathsFor,
  getMetainf,
  getDashboardEventPeriodsState,
  getProjectZoneId,
} from '../../../../../reducers/analyticsApp';
import EventFilterContainer from '../../../../../components/filter/EventFilterContainer';
import {
  filterClauses,
  getEventAttributes,
  getTransferFieldsObject,
  isNotEmptyClause,
} from '../../../../../utils/filter';
import { nullOperators } from '../../../../../constants/filter';
import {
  setFilterVisibility,
  addFilterClause,
  copyFilter,
  removeFilter,
  removeFilterClause,
  setFilterClauseField,
  setFilterClauseValue,
  setClausesConcatOperator,
  setFilterClauseOperator,
  setOthersFilter,
} from '../../../../../actions/dashboards/events';

const mapStateToProps = (state, { unitId, id: eventId }) => {
  const filter = getDashboardEventFilter(state, unitId, eventId);
  const othersFilter = getDashboardEventOthersFilter(state, unitId, eventId);
  const isFiltersValue = filter.clauses
    .filter(({ id }) => id === othersFilter)
    .some(({ operator, value }) => {
      const isNullOperator = nullOperators.includes(operator);
      return isNullOperator || (!!value && (!!value.length || !!Number(value)));
    });

  return {
    othersFilter,
    isFiltersValue,
    composeEvents: getDashboardEvents(state, unitId),
    getFieldFor: (path) => getFieldPathsFor(state, path),
    getFieldKeys: () => getFieldPathKeys(state),
    metainf: getMetainf(state, getDashboardEventName(state, unitId, eventId)),
    zoneId: getProjectZoneId(state),
    concatOperator: filter.concatOperator,
    clauses: filter.clauses,
    visibility: filter.visibility,
    isPeriodsShow: getDashboardEventPeriodsState(state, unitId, eventId).isShow,
    isEvent: true,
    badgeCount: filter.clauses.filter(isNotEmptyClause).length,
  };
};

const mapDispatchToProps = (dispatch, { unitId, id }) => ({
  setFilterVisibility: () => dispatch(setFilterVisibility(unitId, id)),
  onAddFilterClause: (...rest) => dispatch(addFilterClause(unitId, id, ...rest)),
  onCopy: (...rest) => dispatch(copyFilter(unitId, id, ...rest)),
  onRemoveFilter: () => dispatch(removeFilter(unitId, id)),
  onRemoveFilterClause: (...rest) => dispatch(removeFilterClause(unitId, id, ...rest)),
  onSelectFilterClauseField: (...rest) => dispatch(setFilterClauseField(unitId, id, ...rest)),
  onFilterClauseValueChange: (...rest) => dispatch(setFilterClauseValue(unitId, id, ...rest)),
  onSetClausesConcatOperator: (...rest) => dispatch(setClausesConcatOperator(unitId, id, ...rest)),
  onSelectFilterClauseOperator: (...rest) => dispatch(setFilterClauseOperator(unitId, id, ...rest)),
  onOthersChange: (clauseId) => dispatch(setOthersFilter(unitId, id, clauseId)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onCopyFilter: (clauses) => {
    let copyClauses = clauses.filter((clause) => clause.field);
    if (copyClauses.length) {
      // ивент с которого копируется фильтр.
      const firstEvent = stateProps.composeEvents.find((event) =>
        event.filter.clauses.find((clause) => clause.id === copyClauses?.[0].id)
      );
      // тот ивент, на который копируется фильтр.
      const secondEvent = stateProps.composeEvents.find((event) => event.id === ownProps.id);

      const fieldTypes = copyClauses.map(({ field }) =>
        stateProps
          .getFieldKeys()
          .flatMap((pathKey) => stateProps.getFieldFor(pathKey))
          .find((s) => s.path === field)
      );

      // если ивенты не равны то: копируются условия только с одинаковым лейблом, при этом один и тот же лейбл
      // ссылается на разные поля для каждого ивента, поэтому надо достать по лейблу нужный path
      if (firstEvent.name !== secondEvent.name) {
        const { firstEventFields, secondEventFields } = getEventAttributes(
          stateProps.metainf,
          firstEvent.name,
          secondEvent.name
        );
        // общие атрибуты по label
        const commonAttributes = _.intersectionBy(firstEventFields, secondEventFields, 'label');

        const filteredFields = getTransferFieldsObject(
          fieldTypes,
          commonAttributes,
          secondEventFields
        );

        copyClauses = copyClauses.reduce((res, clause) => {
          if (filteredFields[clause.field]) {
            return res.concat({ ...clause, field: filteredFields[clause.field] });
          }

          return res;
        }, []);
      }
    }

    dispatchProps.onCopy(filterClauses(stateProps.metainf, copyClauses));
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EventFilterContainer);
